import styles from './styles.module.scss';
import classNames from 'classnames';
import Button from 'components/Button';
import Wrapper from 'components/Wrapper';
import { CloseModalIconSmall } from 'pages/ServicesCategory/components/AddVendorModal/icons';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { appResetClientDriverAction, appSetShowInviteClientAction } from 'store/actions/app';

const SendInvite = ({
  isLoading,
  stepOne,
  stepTwo,
  step,
  onSubmit,
  inviteLink,
  onSkip,
  hideCopy = false,
}) => {
  const dispatch = useDispatch();
  const [showTooltip, setShowTooltip] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(inviteLink);
    setShowTooltip(true);
    setTimeout(() => setShowTooltip(false), 1000);
  };

  const CopyIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
      <g clipPath="url(#clip0_73338_102072)">
        <path
          d="M8.86393 3.33203L14.47 3.33203C14.912 3.33203 15.3359 3.50763 15.6485 3.82019C15.9611 4.13275 16.1367 4.55667 16.1367 4.9987V12.4987C16.1367 12.9407 15.9611 13.3646 15.6485 13.6772C15.3359 13.9898 14.912 14.1654 14.47 14.1654H8.86393C8.4219 14.1654 7.99798 13.9898 7.68542 13.6772C7.37286 13.3646 7.19727 12.9407 7.19727 12.4987V4.9987C7.19727 4.55667 7.37286 4.13275 7.68542 3.82019C7.99798 3.50763 8.4219 3.33203 8.86393 3.33203Z"
          stroke="#4673D1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.8027 14.168V15.8346C12.8027 16.2767 12.6271 16.7006 12.3145 17.0131C12.002 17.3257 11.578 17.5013 11.136 17.5013H5.52995C5.08792 17.5013 4.664 17.3257 4.35144 17.0131C4.03888 16.7006 3.86328 16.2767 3.86328 15.8346V8.33464C3.86328 7.89261 4.03888 7.46869 4.35144 7.15612C4.664 6.84356 5.08792 6.66797 5.52995 6.66797H7.19661"
          stroke="#4673D1"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_73338_102072">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );

  return (
    <Wrapper className={styles.modal} isPending={isLoading}>
      {step !== 1 && (
        <div className={styles.close}>
          <div
            onClick={() => {
              dispatch(appSetShowInviteClientAction(false));
              dispatch(appResetClientDriverAction({}));
            }}
          >
            <CloseModalIconSmall />
          </div>
        </div>
      )}
      {step === 1 ? stepOne : stepTwo}
      {step === 1 && (
        <>
          <Button title={'Send Now'} className={styles.button} onClick={onSubmit} />
          <Button
            title={'Skip'}
            className={classNames(styles.button, styles.skip)}
            onClick={onSkip}
          />
        </>
      )}
      {inviteLink && !hideCopy ? (
        <div className={styles.copyContainer}>
          <p className={styles.copy} onClick={handleCopy}>
            <CopyIcon />
            Copy invitation link
            {
              <span className={classNames(styles.tooltip, { [styles.show]: showTooltip })}>
                Link Copied
              </span>
            }
          </p>
        </div>
      ) : null}
    </Wrapper>
  );
};

export default SendInvite;
